/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { InputProps } from "./interfaces";
import { inputFieldStyles } from "./styles";

export const InputField: React.FunctionComponent<InputProps> = (props) => {
  const [value, setValue] = React.useState<string | number>(
    props.initialValue || ""
  );
  const [validationError, setValidationError] = React.useState<boolean>(false);
  const [isValid, setIsValid] = React.useState<boolean>(true);

  React.useEffect(() => {
    props.initialValue && setValue(props.initialValue);
  }, [props.initialValue]);

  const [showPassword, setShowPassword] = React.useState<boolean>(false);

  const validate = (val: any) => {
    if (props.validationRegEx && val.toString().length) {
      const result = props.validationRegEx.test(val.toString());
      setIsValid(result);
      if (validationError && result) {
        setValidationError(false);
      }
      if (props.validate) {
        props.validate(result);
      }
    }
  };

  return (
    <div
      className={`
        ${props.className ? props.className : ""}`}
      style={props.style}
      css={inputFieldStyles(props.capitaliseInput)}
    >
      <input
        type={
          props.type === "password" && props.enableShowHide
            ? showPassword
              ? "text"
              : "password"
            : props.type
        }
        name={props.name ? props.name : ""}
        className={`input-field 
          ${value.toString().length ? "input-field-valid" : ""}`}
        onChange={(e) => {
          const value = e.target.value;
          setValue(value);
          validate(value);
          props.onChange(value);
        }}
        value={
          props.initialValue && props.disabled === true
            ? props.initialValue
            : value
        }
        disabled={props.disabled ? props.disabled : false}
        required={props.required ? props.required : false}
        onBlur={() => {
          setValidationError(!isValid);
        }}
      />
      <div className="floating-placeholder">{props.placeholder}</div>
      {props.type === "password" && props.enableShowHide && (
        <React.Fragment>
          {!showPassword && (
            <span
              className="input-action"
              onClick={() => {
                setShowPassword(true);
              }}
            >
              SHOW
            </span>
          )}
          {showPassword && (
            <span
              className="input-action"
              onClick={() => {
                setShowPassword(false);
              }}
            >
              HIDE
            </span>
          )}
        </React.Fragment>
      )}
      {validationError && (
        <div className="validation-err-msg">
          {props.validationErrMsg
            ? props.validationErrMsg
            : "Please enter the correct value"}
        </div>
      )}
    </div>
  );
};
